export function ReleaseUnavailable() {
  return (
    <div className='flex flex-col items-center gap-4 text-center'>
      <h2 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
        We could not load the latest release
      </h2>
      <p className='max-w-md text-[var(--color-text-secondary)]'>
        Something went wrong fetching the Ahoy Desktop download. Please refresh
        the page or try again in a moment.
      </p>
    </div>
  );
}
